import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import classnames from 'classnames'

import { IonIcon } from 'controls'
import ContractFeaturesFlag from 'components/ContractFeaturesFlag'

import { menuItem as menuItemStyles } from './styles'
import { resolveHref } from './utils'

const MenuItem = ({ item, expanded, padded, token, onExpand, onItemClick }) => {
  const { name, icon, href, as, isNew, isBeta, external, contractFeature } = item

  const resolvedHref = resolveHref(href, token)
  const resolvedAs = as ? resolveHref(as, token) : undefined

  const handleClick = (e) => {
    if (!expanded && onExpand) {
      e.preventDefault()
      onExpand()
    }
    if (onItemClick) {
      onItemClick()
    }
  }

  const content = (
    <li>
      <Link href={resolvedHref} as={resolvedAs}>
        <a
          className={classnames('menu-item', { padded })}
          title={!expanded ? name : undefined}
          target={external ? '_blank' : undefined}
          rel={external ? 'noopener noreferrer' : undefined}
          onClick={handleClick}
        >
          {(isNew || isBeta) && expanded && (
            <span className={classnames({ 'is-new': isNew, 'is-beta': isBeta })}>
              {isNew && <IonIcon size="small" icon="md-star" style={{ margin: 0 }} />}
              {isBeta && 'Beta'}
            </span>
          )}
          {icon && <IonIcon size="small" icon={icon} />}
          {expanded && <span>{name}</span>}
          <style jsx>{menuItemStyles}</style>
        </a>
      </Link>
    </li>
  )

  if (contractFeature) {
    return (
      <ContractFeaturesFlag contractFeature={contractFeature}>
        {content}
      </ContractFeaturesFlag>
    )
  }

  return content
}

MenuItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]).isRequired,
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
    isNew: PropTypes.bool,
    isBeta: PropTypes.bool,
    external: PropTypes.bool,
    contractFeature: PropTypes.string
  }).isRequired,
  expanded: PropTypes.bool,
  padded: PropTypes.bool,
  token: PropTypes.string,
  onExpand: PropTypes.func,
  onItemClick: PropTypes.func
}

MenuItem.defaultProps = {
  expanded: true,
  padded: false,
  token: '',
  onExpand: null,
  onItemClick: () => {}
}

export default MenuItem
